import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from 'react';
import { cn } from '@morpho-org/ui-v6/utils';
export interface ChartStatusRootProps extends PropsWithChildren {
  className?: string;
  borderRadius: number;
  hideBorder?: boolean;
}

/**
 * Tailwind replica of the V5 `ChartStatusRoot` styled div
 * (src/ui-v5 (legacy kit)/charts/Chart/ChartStatus/ChartStatus.styles.ts).
 *
 * Note: intentionally NOT positioned — absolutely positioned children (e.g.
 * the "0" label in ChartStatusNoData) anchor to the relative Chart root,
 * exactly like in V5.
 */
export function ChartStatusRoot(t0) {
  const $ = _c(9);
  const {
    className,
    borderRadius,
    hideBorder,
    children
  } = t0;
  const t1 = !hideBorder && "border border-solid border-border";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = cn("mb-[29px] flex h-[calc(100%-29px)] w-full items-center justify-center", t1, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `${borderRadius}px`;
  let t4;
  if ($[3] !== t3) {
    t4 = {
      borderRadius: t3
    };
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children || $[6] !== t2 || $[7] !== t4) {
    t5 = <div className={t2} style={t4}>{children}</div>;
    $[5] = children;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}